import COLORS from "@/styles/colors";

export default {
  PRIMARY: {
    SIDE_PANEL_BACKGROUND: COLORS.DUSK_BLUE,
  },
};
